import { TextInput } from 'react-admin';
import TinyMCEInput from '../TinyMCEInput';

const DonationFooter = ({ index, source, }: { source: string, index: number }) => {
  return (<div style={{
    display: 'grid',
    gap: '0px',
    columnGap: '10px',
    gridTemplateAreas: `'title_en title_tc title_sc' 'html_en html_en html_en' 'html_tc html_tc html_tc' 'html_sc html_sc html_sc'`
  }}>
    <TextInput source={`${source}.title_en`} label="Title EN" fullWidth sx={{ gridArea: 'title_en' }} />
    <TextInput source={`${source}.title_tc`} label="Title TC" fullWidth sx={{ gridArea: 'title_tc' }} />
    <TextInput source={`${source}.title_sc`} label="Title SC" fullWidth sx={{ gridArea: 'title_sc' }} />
    <TinyMCEInput source={`${source}.html_en`} label="Content EN" fullWidth helperText={false} sx={{ gridArea: 'html_en' }} />
    <TinyMCEInput source={`${source}.html_tc`} label="Content TC" fullWidth helperText={false} sx={{ gridArea: 'html_tc' }} />
    <TinyMCEInput source={`${source}.html_sc`} label="Content SC" fullWidth helperText={false} sx={{ gridArea: 'html_sc' }} />
  </div>
  )
}

export default DonationFooter;
